import React from "react"
import { Container } from "reactstrap"
//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { Helmet } from "react-helmet"
import { useGetPagesDataQuery } from "redux/cms/api"
import CmsTab from "../Common/Tab"
function AboutUs() {
  const { data, isLoading, isSuccess, refetch } =
    useGetPagesDataQuery("about-us")

  const BreadcrumbDetails = {
    breadcrumbItem: {
      label: "About us",
      link: "/pages/about-us",
    },
    paths: [
      {
        label: "Pages",
        link: "/pages/about-us",
      },
    ],
  }

  return (
    <React.Fragment>
      <Helmet>
        <title>About us | Discover Equestrian</title>
      </Helmet>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs breadcrumbDetails={BreadcrumbDetails} />
          <CmsTab
            data={data}
            isLoading={isLoading}
            isSuccess={isSuccess}
            tab={"About us"}
            refetch={refetch}
          />
        </Container>
      </div>
    </React.Fragment>
  )
}

export default AboutUs
